// assets
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import GoldOutlined from '@ant-design/icons/GoldOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import ClusterOutlined from '@ant-design/icons/ClusterOutlined';
import BgColorsOutlined from '@ant-design/icons/BgColorsOutlined';

// icons
const icons = { DatabaseOutlined, GoldOutlined, WarningOutlined, ClusterOutlined, BgColorsOutlined };

// ==============================|| MENU ITEMS - CROPS ||============================== //

const crops = {
  id: 'group-crops',
  title: 'Knowledge Platform',
  type: 'group',
  children: [
    {
      id: 'crops',
      title: 'Crops',
      type: 'item',
      url: '/crops',
      icon: icons.DatabaseOutlined,
      breadcrumbs: false
    },
    {
      id: 'products',
      title: 'Products',
      type: 'item',
      url: '/products',
      icon: icons.GoldOutlined,
      breadcrumbs: false
    },
    {
      id: 'weeds',
      title: 'Weeds',
      type: 'item',
      url: '/weeds',
      icon: icons.WarningOutlined,
      breadcrumbs: false
    },
    {
      id: 'trees',
      title: 'Trees',
      type: 'item',
      url: '/trees',
      icon: icons.ClusterOutlined,
      breadcrumbs: false
    },
    {
      id: 'flowers',
      title: 'Flowers',
      type: 'item',
      url: '/flowers',
      icon: icons.BgColorsOutlined,
      breadcrumbs: false
    }
  ]
};

export default crops;
